import { IRow } from "../types";

export const form2HeaderCells = [
    "№п/п",
    "Наименование показателя, единица измерения",
    "Значение показателя*",
    "Формула для расчета значения показателя",
    `
    Документы, подтверждающие значение показателя (при необходимости предъявляются по
    дополнительному запросу)`,
    `
    Загруженные файлы`,
];

export const form2Rows: IRow[] = [
    {
        col1: "1",
        col2: "Участие в федеральных и международных мероприятиях с целью презентации услуг и продвижения деятельности центра, единиц",
        col3: { name: "info.f2.n1.0" },
        col4: "не требуется",
        col5: 'Копии локальных актов ВУЗа, подтверждающих участие, или ссылки на публикации в сети Интернет и СМИ (показатель ВУЗа, учитывается в мониторинге "Наука-2")',
        col6: { name: "info.f2.n1.2", fileList: true },
    },
    {
        col1: "2",
        col2: "Количество публикаций в средствах массовой информации и сети Интернет, в том числе научных изданиях, единиц",
        col3: { name: "info.f2.n2.0" },
        col4: "не требуется",
        col5: 'Ссылки на публикации в сети Интернет и СМИ (показатель ВУЗа, учитывается в мониторинге "Мониторинг -1")\nСсылки на фото- и видеоматериалы',
        col6: { name: "info.f2.n2.2", fileList: true },
    },
    {
        col1: "3",
        col2: "Количество резидентов, которые создали на базе центра прототипы/ творческие продукты (проекты), единиц\n",
        col3: { name: "info.f2.n3.0" },
        col4: "не требуется",
        col5: "Ссылки на фото-  и видеоматериалы",
        col6: { name: "info.f2.n3.2", fileList: true },
    },
    {
        col1: "",
        col2: "3.1. Количество человек, прошедших обучение в рамках образовательных модулей, человек",
        col3: { name: "info.f2.n3_1.0" },
        col4: "не требуется",
        col5: "Копии локальных актов ВУЗа, подтверждающих количество человек, прошедших обучение в рамках образовательных модулей",
        col6: { name: "info.f2.n3_1.2", fileList: true },
    },
    {
        col1: "",
        col2: "3.2. Количество человек, прошедших обучение в рамках мастер-классов, человек",
        col3: { name: "info.f2.n3_2.0" },
        col4: "не требуется",
        col5: "Копии журнала регистрации участников мастер-классов",
        col6: { name: "info.f2.n3_2.2", fileList: true },
    },
    {
        col1: "",
        col2: "3.3. Количество человек, прошедших обучение в рамках курсов повышения квалификации, человек",
        col3: { name: "info.f2.n3_3.0" },
        col4: "не требуется",
        col5: 'Копии локальных актов ВУЗа, подтверждающих количество человек, прошедших обучение в рамках курсов повышения квалификации. Отчет ФИС ФРДО (показатель ВУЗа, учитывается в мониторинге "1-ПК")',
        col6: { name: "info.f2.n3_3.2", fileList: true },
    },
    {
        col1: "",
        col2: "3.4. Количество человек, прошедших обучение в рамках профессиональной переподготовки кадров, человек",
        col3: { name: "info.f2.n3_4.0" },
        col4: "не требуется",
        col5: 'Копии локальных актов ВУЗа, подтверждающих количество человек, прошедших обучение в рамках курсов профессиональной переподготовки кадров. Отчет ФИС ФРДО (показатель ВУЗа, учитывается в мониторинго"1-ПК")',
        col6: { name: "info.f2.n3_4.2", fileList: true },
    },
    {
        col1: "",
        col2: "3.5. Количество резидентов (физических и юридических лиц), которые создали на базе центра прототипы/ творческие продукты (проекты) в рамках оказания дополнительных услуг, единиц",
        col3: { name: "info.f2.n3_5.0" },
        col4: "не требуется",
        col5: 'Копии договоров об оказании дополнительных услуг по созданию попрототипов/ творческих продуктов (проектов) в соответствии с уставной деятельностью ВУЗа (показатель ВУЗа, учитывается в мониторинге "Наука-2")',
        col6: { name: "info.f2.n3_5.2", fileList: true },
    },
    {
        col1: "4",
        col2: "Количество созданных прототипов/творческих продуктов (проектов) по итогам оказания услуг, единиц",
        col3: { name: "info.f2.n4.0" },
        col4: `Кс=(ПРом+ПРмк+ПРкпк+ПРппк+ПР), где:
Кс - количество созданных прототипов/творческих продуктов (проектов) по итогам оказания услуг;
ПРом - количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках образовательных модулей;                              ПРмк - количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках мастер-классов;
ПРкпк - количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках курсов повышения квалификации;
ПРппк - количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках профессиональной переподготовки кадров;                                                                                                                                                         ПР - количество созданых попрототипов/творческих продуктов (проектов) по итогам оказания дополнительных услуг, в том числе на основе собстввенных разработок и/или совместных разработок со сторонними заказчиками                                                                                                                                                                                                                                                                                                                                                                                                `,
        col5: "",
        col6: { name: "info.f2.n4.2", fileList: true },
    },
    {
        col1: "",
        col2: "4.1. Количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках образовательных модулей, единиц",
        col3: { name: "info.f2.n4_1.0" },
        col4: "не требуется",
        col5: "Копии локальных актов ВУЗа, подтверждающих количество созданных прототипов творческих продуктов (проектов) по итогам прохождения обучения в рамках образовательных модулей",
        col6: { name: "info.f2.n4_1.2", fileList: true },
    },
    {
        col1: "",
        col2: "4.2. Количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках мастер-классов, единиц",
        col3: { name: "info.f2.n4_2.0" },
        col4: "не требуется",
        col5: 'Копии журнала регистрации участников мастер классов с указанием созданных прототипов/творческих продуктов (проектов) (показатель ВУЗа, учитывается в мониторинге "Наука-2")',
        col6: { name: "info.f2.n4_2.2", fileList: true },
    },
    {
        col1: "",
        col2: "4.3. Количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках курсов повышения квалификации, единиц",
        col3: { name: "info.f2.n4_3.0" },
        col4: "не требуется",
        col5: 'Копии локальных актов ВУЗа, подтверждающих количество созданных прототипов творческих продуктов (проектов) по итогам прохождения обучения в рамках курсов повышения квалификация (показатель ВУЗа, учитывается в мониторинге "Наука - 2")',
        col6: { name: "info.f2.n4_3.2", fileList: true },
    },
    {
        col1: "",
        col2: "4.4. Количество созданных прототипов/творческих продуктов (проектов) по итогам прохождения обучения в рамках курсов профессиональной переподготовки кадров, единиц",
        col3: { name: "info.f2.n4_4.0" },
        col4: "не требуется",
        col5: 'Копии локальных актов ВУЗа, подтверждающих количество созданных прототипов творческих продуктов (проектов) по итогам прохождения обучения в рамках курсов профессиональюй переподготовки кадров (показатель ВУЗа, учитывается в мониторинге "Наука - 2")',
        col6: { name: "info.f2.n4_4.2", fileList: true },
    },
    {
        col1: "",
        col2: "4.5. Количество созданных попрототипов/творческих продуктов (проектов) по итогам оказания дополнительных услуг, в том числе на основе собственных разработок и/или совместных разработок со сторонними заказчиками, единиц",
        col3: { name: "info.f2.n4_5.0" },
        col4: "не требуется",
        col5: 'Копии договоров об оказании дополнительных услуг по созданию попрототипов творческих продуктов (проектов) в соответствии с уставной деятельностью ВУЗа (показатель ВУЗа, учитывается в мониторинге "Наука 2")',
        col6: { name: "info.f2.n4_5.2", fileList: true },
    },
    {
        col1: "5",
        col2: "Количество зарегистрированных патентов и авторских прав на результаты творческой деятельности, единиц",
        col3: { name: "info.f2.n5.0" },
        col4: `КЗ=ПА+АП, где:
КЗ- количество зарегистрированных  патентов и авторских прав на результаты творческой деятельности;
ПА- количество зарегистрированных  патентов на результаты творческой деятельности;
АП- количество зарегистрированных  авторских прав на результаты творческой деятельности`,
        col5: 'Показатель ВУЗа, учитывается в мониторинге "Наука-2"',
        col6: { name: "info.f2.n5.2", fileList: true },
    },
    {
        col1: "",
        col2: "5.1. Количество зарегистрированных авторских прав на результаты творческой деятельности, единиц",
        col3: { name: "info.f2.n5_1.0" },
        col4: "не требуется",
        col5: 'Копии сертификатов или иных документов, подтверждающих количество зарегистрированных авторских прав (показатель ВУЗа, учитывается в мониторинге "Наука-2")',
        col6: { name: "info.f2.n5_1.2", fileList: true },
    },
    {
        col1: "",
        col2: "5.2. Количество зарегистрированных патентов на результаты творческой деятельности, единиц",
        col3: { name: "info.f2.n5_2.0" },
        col4: "не требуется",
        col5: "Копии сертификатов или иных документов, подтверждающих количество зарегистрированных патентов",
        col6: { name: "info.f2.n5_2.2", fileList: true },
    },
    {
        col1: "6",
        col2: "Объем оказанных услуг, тыс.рублей",
        col3: { name: "info.f2.n6.0" },
        col4: `ОУ=Они+Оод+Оив, где:
ОУ- объем оказанных услуг;
Они- объем оказанных услуг по итогам научно-инновационной деятельности;
Оод- объем оказанных услуг по итогам образовательной деятельности;
Оив- объем оказанных услуг по итогам иных видов  деятельности`,
        col5: 'Показатель ВУЗа, учитывается в мониторинге "Наука-2"',
        col6: { name: "info.f2.n6.2", fileList: true },
    },
    {
        col1: "",
        col2: "6.1. Объем оказанных услуг по итогам научно-инновационной деятельности (количество патентов и зарегистрированных авторских прав), тыс.рублей",
        col3: { name: "info.f2.n6_1.0" },
        col4: "не требуется",
        col5: 'Копии платежных или иных финансовых документов, договоров и актов оказанных услуг, подтверждающих значение показателя (показатель ВУЗа, учитывается в мониторниго "Наука-2")',
        col6: { name: "info.f2.n6_1.2", fileList: true },
    },
    {
        col1: "",
        col2: "6.2. Объем оказанных услуг по итогам образовательной деятельности, тыс.рублей",
        col3: { name: "info.f2.n6_2.0" },
        col4: "не требуется",
        col5: 'Копии платежных или иных финансовых документов, договоров и актов оказанных услуг, подтверждающих значение показателя (показатель ВУЗа, учитывается в мониторинге "Наука-2")',
        col6: { name: "info.f2.n6_2.2", fileList: true },
    },
    {
        col1: "",
        col2: "6.3. Объем оказанных услуг по итогам иных вида деятельности (дополнительные услуги), тыс.рублей",
        col3: { name: "info.f2.n6_3.0" },
        col4: "не требуется",
        col5: "Копии платежных или иных финансовых документов, договоров и актов азанных услуг. подтверждающих значи показателя",
        col6: { name: "info.f2.n6_3.2", fileList: true },
    },
];
